import React from 'react';
import { CtaButton } from './ui/CtaButton';
import { WHATSAPP_ORDER_LINK } from '../utils/whatsapp';
export function StickyMobileCta() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-aqua-400/25 bg-night-900/95 px-4 py-2.5 backdrop-blur md:hidden" data-id="element-134" data-mp="lrdqfn4ic391">
      <div className="flex items-center justify-between gap-3" data-id="element-135" data-mp="vr4jrlhc0c7j">
        <span className="font-display text-[13px] uppercase tracking-wide text-white" data-id="element-136" data-mp="vqlasu9nsy5n">
          ¿Listo para pedir?
        </span>
        <CtaButton href={WHATSAPP_ORDER_LINK} size="sm" track="whatsapp-sticky-mobile-click" data-id="element-137" data-mp="32p91b58gg20">
          Pedir por WhatsApp
        </CtaButton>
      </div>
    </div>;
}